import { render, staticRenderFns } from "./currency_hedge.vue?vue&type=template&id=094fa090&scoped=true&"
import script from "./currency_hedge.vue?vue&type=script&lang=js&"
export * from "./currency_hedge.vue?vue&type=script&lang=js&"
import style0 from "./currency_hedge.vue?vue&type=style&index=0&id=094fa090&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "094fa090",
  null
  
)

export default component.exports